"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Stepper = _interopRequireDefault(require("@mui/material/Stepper"));
var _react = _interopRequireDefault(require("react"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _StepperStep = _interopRequireDefault(require("./StepperStep.js"));
var _StepperModule = _interopRequireDefault(require("./Stepper.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Stepper component
 */const Stepper = props => {
  const {
    activeStep,
    className,
    steps,
    vertical
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stepper.default, {
    activeStep: activeStep,
    classes: _StepperModule.default,
    className: className,
    orientation: vertical ? "vertical" : "horizontal",
    children: steps.map((step, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepperStep.default, {
      label: step.label,
      onClick: step.onClick,
      value: key
    }, key))
  });
};
var _default = exports.default = (0, _withMobile.default)(Stepper);